module.exports = __webpack_public_path__ + "static/media/joffre-1.a4a790c0.jpg";